// extracted by mini-css-extract-plugin
module.exports = {"dots":"LoadingDots_dots__nI7G9","dotFlashing":"LoadingDots_dotFlashing__Z3Bih"};